import { ActionReducer, createFeature } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store/src/reducer';
import { routerReducer } from '@ngrx/router-store';

export const routerFeature = createFeature({
  name: 'router',
  reducer: routerReducer as ActionReducer<RouterReducerState>,
});
